import { render, staticRenderFns } from "./BoardListItem.vue?vue&type=template&id=d37481ac&scoped=true"
import script from "./BoardListItem.vue?vue&type=script&lang=js"
export * from "./BoardListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37481ac",
  null
  
)

export default component.exports